export const CLICK_OUTSIDE_EVENT = 'mousedown';

/**
 * URL path segments that are not event keys.
 * Used by EventProvider to skip category resolution on non-event routes.
 */
export const NON_EVENT_PATH_SEGMENTS = [
    'cart',
    'checkout',
    'account',
    'order',
    'ping-callback',
    'invoice-confirmation',
] as const;
export const EVENT_KEY_PATH_INDEX = 1;
/**
 * Locale codes used when searching for a category by slug fallback.
 * Add more locales here if the Commercetools project supports them.
 */
export const CATEGORY_SLUG_LOCALES = ['en'] as const;
